import React from "react";
import { CheckCircle } from "lucide-react";
import Edutechcycle from "./Edutechcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Grow Your EdTech with WhatsApp",
  points: [
    "Send friendly reminders for tests, fees, and results.",
    "Make learning easier, affordable, and flexible for students.",
    "Chat one-on-one with students for a personal touch.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/edutech/EdTech_1.png",
};

const edTechServices = [
  {
    id: 1,
    icon: <span className="text-2xl">📚</span>, // Books icon
    title: "Enhance Student Engagement with WhatsApp",
    description: "Keep students motivated with course updates, reminders, and interactive chats on WhatsApp. It’s like having a virtual classroom in their pocket!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🎓</span>, // Graduation cap icon
    title: "Simplify Admissions on WhatsApp",
    description: "Guide prospective students through enrollment, answer queries, and send welcome kits all via WhatsApp. It’s a stress-free way to grow your reach."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📹</span>, // Video icon
    title: "Share Learning Materials via WhatsApp",
    description: "Distribute videos, PDFs, and quizzes through WhatsApp to make learning accessible anytime, anywhere. Your students will thank you for the convenience."
  },
  {
    id: 4,
    icon: <span className="text-2xl">💻</span>, // Laptop icon
    title: "Support Tech Issues on WhatsApp",
    description: "Resolve platform glitches, answer tech questions, and ensure smooth learning with real-time WhatsApp support. It’s a lifesaver for both students and teachers."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Schedule Classes Easily on WhatsApp",
    description: "Let students book tutoring sessions, webinars, or office hours via WhatsApp. It’s flexible, user-friendly, and keeps everyone on track."
  },
  {
    id: 6,
    icon: <span className="text-2xl">📈</span>, // Chart icon
    title: "Track Progress with WhatsApp Updates",
    description: "Send grade reports, attendance alerts, and achievement notifications via WhatsApp. It’s a simple way to keep parents and students in the loop."
  }
];

const edTechFAQs = [
  {
    question: "How can WhatsApp improve student engagement in EdTech?",
    answer: "WhatsApp keeps students engaged by sending course updates, reminders, and interactive chats. It’s like having a virtual classroom that fits in their pocket, making learning more accessible and fun!"
  },
  {
    question: "Can WhatsApp help with online course enrollments?",
    answer: "Yes! Use WhatsApp to guide prospective students through admissions, answer questions, and send welcome kits. It’s a smooth, personal way to grow your student base."
  },
  {
    question: "Is WhatsApp secure for sharing educational materials?",
    answer: "Definitely! WhatsApp’s encryption ensures safe sharing of videos, PDFs, and quizzes. It’s like delivering textbooks directly to students without any risk."
  },
  {
    question: "How does WhatsApp support teachers and students?",
    answer: "WhatsApp offers real-time support for tech issues, homework help, and exam tips. It’s like having a tutor available 24/7, boosting both teaching and learning efficiency."
  },
  {
    question: "Can EdTech platforms schedule classes on WhatsApp?",
    answer: "Yes, and it’s easy! Students can book tutoring sessions or webinars via WhatsApp, with automatic reminders to keep everyone on track. It’s a flexible solution that saves time."
  },
  {
    question: "How can WhatsApp track student progress?",
    answer: "Send grade reports, attendance alerts, and achievement notifications via WhatsApp. It’s like giving parents and students a dashboard they can check anytime, anywhere."
  },
  {
    question: "What kind of content can EdTech share on WhatsApp?",
    answer: "You can share lesson plans, study guides, and motivational messages through WhatsApp. It’s a direct line to keep students inspired and on track with their goals."
  },
  {
    question: "Can WhatsApp reduce administrative workload for EdTech?",
    answer: "Absolutely! Automate responses to common queries and manage enrollments via WhatsApp, freeing up your team for teaching. It’s like having an extra hand in the office!"
  },
  {
    question: "How do students feel about using WhatsApp for learning?",
    answer: "They love it! Students appreciate the convenience, speed, and personal touch of WhatsApp. It’s less formal than emails and more immediate, making education feel modern."
  },
  {
    question: "How do I integrate WhatsApp into my EdTech platform?",
    answer: "Start by linking WhatsApp Business to your system, creating chat templates for common tasks, and training your team. Platforms like ChatMitra can help you set up quickly and effectively!"
  },
];


const Edutech = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Grow Your EdTech with WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                <a
                key={index}
                href={button.buttonLink}
                className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
              >
                {button.text}
              </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="EdTech Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Ready to transform your EdTech game? Start with ChatMitra today—no credit card needed!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Edutechcycle />
      <WhatsAppServices servicesData={edTechServices} isVisible={true}/>
      <Faqs faqs={edTechFAQs} />
      <Footer />

      <title>WhatsApp for EdTech | ChatMitra</title>
      <meta name="description" content="Boost your EdTech with WhatsApp. Enroll students, send reminders, and engage them with ChatMitra’s automation tools." />
      <meta name="keywords" content="WhatsApp for EdTech, student engagement, EdTech enrollment, education automation, course reminders" />
      <meta property="og:title" content="WhatsApp for EdTech | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to grow your EdTech business with easy enrollment, personal chats, and automated updates." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-edutech" />
      <meta property="og:type" content="website" />
    </>
  );
};

export default Edutech;